import { render, staticRenderFns } from "./TableSlopes.vue?vue&type=template&id=30835aeb"
import script from "./TableSlopes.vue?vue&type=script&lang=js"
export * from "./TableSlopes.vue?vue&type=script&lang=js"
import style0 from "./TableSlopes.vue?vue&type=style&index=0&id=30835aeb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports